import { FETCH_MINI_CART } from '../constants/ActionTypes';
import axios from 'axios';


export default function fetchMiniCart() {

  const promise=axios.get(`/api/market/getSessCartSummary`);

  const action={
    type: FETCH_MINI_CART,
    payload: promise
  };

  return action;

}

